import React from 'react';
import PropTypes from 'prop-types';

import {Alert, Box, Button, Paper, Stack, Typography} from 'views/components';
import {Edit as EditIcon} from 'views/icons';
import {Translate} from 'views/module';

import InterviewQuestionsDialog from './InterviewQuestionsDialog';

const InterviewQuestions = (props) => {
  const {interviewQuestions, interviewQuestionsError, jobBackend} = props;

  const [isEditOpen, setIsEditOpen] = React.useState(false);

  return (
    <Paper sx={{p: 3, borderRadius: 5}}>
      <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="flex-start">
        <Typography variant="h6" gutterBottom sx={{fontWeight: 600}}>
          <Translate expression="career.jobDetail.InterviewQuestions.Title" />
        </Typography>
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon />}
          disabled={!interviewQuestions}
          onClick={() => setIsEditOpen(true)}
        >
          <Translate expression="career.jobDetail.InterviewQuestions.Edit" />
        </Button>
      </Stack>
      {
        interviewQuestionsError &&
        <Alert severity="error">
          <Translate expression="career.jobDetail.InterviewQuestions.Errors.Load" />
        </Alert>
      }
      {
        interviewQuestions?.length === 0 &&
        <Typography variant="body2" color="text.secondary">
          <Translate expression="career.jobDetail.InterviewQuestions.Empty" />
        </Typography>
      }
      {
        interviewQuestions?.length > 0 &&
        <Box component="ol" sx={{m: 0, pl: 2.5}}>
          {
            interviewQuestions.map((question) => (
              <Typography
                key={question.id}
                component="li"
                variant="body2"
                color="text.secondary"
                sx={{whiteSpace: 'pre-wrap', mb: 0.5}}
              >
                {question.text}
              </Typography>
            ))
          }
        </Box>
      }
      {
        isEditOpen &&
        <InterviewQuestionsDialog
          questions={interviewQuestions}
          onClose={() => setIsEditOpen(false)}
          onSave={(questions) => jobBackend.interviewQuestions.save(questions, () => setIsEditOpen(false))}
        />
      }
    </Paper>
  );
};

InterviewQuestions.propTypes = {
  interviewQuestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })),
  interviewQuestionsError: PropTypes.object,
  jobBackend: PropTypes.shape({
    interviewQuestions: PropTypes.shape({
      save: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
};

export default React.memo(InterviewQuestions);
